module.exports = __webpack_public_path__ + "static/media/user-13.ba72a5bd.png";